<template>
  <div :class="boxColor"
       class="flex w-full justify-between align-center">
    <div class="smart-logo">
      <SmartLogo
        :white="true"
      />
    </div>
    <div class="mr-3">
      <router-link class="text-white" to="/">
        Sair
      </router-link>
    </div>
  </div>
</template>

<script>
// @flow
const avaliableColors = ['blue', 'transparent'];

export default {
  name: 'SmartMenu',
  components: {
    SmartLogo: () => import('packages/SmartLogo')
  },
  props: {
    paragraph: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'blue',
      validator(value: string): boolean {
        return avaliableColors.includes(value);
      }
    },
    user: {
      type: String,
      required: true
    }
  },
  computed: {
    boxColor() {
      return `back-color--${this.color}`;
    }
  }
};

</script>

<style scoped lang="scss">

.smart-logo {
  width: 45px;
  height: 45px;
}

a {
  text-decoration: none;
}

.back-color {
  &--blue {
    background-color: $color-brand-primary ;
  }
  &--transparent {
    background-color: transparent;
  }
}

</style>
